import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Text } from '@react-pdf/renderer';
// react-pdf has no superscript support, so we use this to properly render superscript as intended
const getTitleMarkdown = (string, titleFontSize) => {
    const parser = new DOMParser();
    const title = parser.parseFromString(string, 'text/html');
    const nodes = title.body.childNodes;
    const textElements = [];
    nodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
            textElements.push(_jsx(Text, { style: { fontSize: titleFontSize, fontWeight: 'bold' }, children: node.textContent }));
        }
        else if (node.nodeType === Node.ELEMENT_NODE) {
            textElements.push(_jsx(Text, { style: { fontSize: '10px', fontWeight: 'bold', transform: 'translateY(-6px)' }, children: node.textContent }));
        }
    });
    return textElements;
};
export default getTitleMarkdown;
